/**
 * The icon for check.
 * https://www.figma.com/design/LHoF60AgvlnXcwv25cns5j/ARTICLE-PAGE--WEB---APP-?node-id=7312-70886&t=Ye5oCfx49u4QSpQf-4
 */
const IconCheck = () => {
  return (
    <path
      d="M18.7598 7.7627L18.3779 8.25781L11.1592 17.6377L10.7051 18.2285L10.2031 17.6787L5.42188 12.4521L5 11.9912L5.92188 11.1475L6.34375 11.6084L10.6221 16.2852L17.3877 7.49609L17.7686 7L18.7598 7.7627Z"
      fill="currentColor"
      data-testid="icon-check"
    />
  );
};

export default IconCheck;
